import {createAction} from '@reduxjs/toolkit';
import {
    getActiveAccountProfileLicense,
    getActiveAccountProfileLicenseFailure,
    getActiveAccountProfileLicenseRequest,
    getActiveAccountProfileLicenseSuccess,
} from 'src/openapi/admin/apis/AccountActiveLicenseApi';

const types = [
    createAction<Parameters<typeof getActiveAccountProfileLicenseRequest>[0]>('USER_DRAWER_LICENSE_REQUEST'),
    createAction<Parameters<typeof getActiveAccountProfileLicenseSuccess>[0]>('USER_DRAWER_LICENSE_SUCCESS'),
    createAction<Parameters<typeof getActiveAccountProfileLicenseFailure>[0]>('USER_DRAWER_LICENSE_FAILURE'),
] as const;

export const getDrawerLicense = (accountId: number, signal: AbortSignal) => {
    const action = getActiveAccountProfileLicense({accountId}, {signal});
    return {...action, CALL_API: {...action.CALL_API, types}};
};
